import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { JobService } from '@shared';
import { sendAddAsProspect } from '@shared/add-prospect/store/add-prospect.actions';
import { JobStatusEnum } from '@shared/models/job-statuses';
import { of } from 'rxjs';

export interface AddProspectModalData {
  candidateId: number;
}

@Component({
  templateUrl: './add-prospect-modal.component.html',
  styleUrls: ['./add-prospect-modal.component.scss'],
})
export class AddProspectModalComponent implements OnInit {
  jobFormControl: FormControl = this.fb.control(null, [Validators.required]);
  form = new FormGroup({
    job: this.jobFormControl,
  });

  jobs$ = of([]);

  constructor(
    private dialogRef: MatDialogRef<AddProspectModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddProspectModalData,
    private jobService: JobService,
    private fb: FormBuilder,
    private store: Store,
  ) {}

  ngOnInit(): void {}

  closeDialog() {
    this.dialogRef.close();
  }

  onInputChange(input: string) {
    if (this.jobFormControl.value == null) {
      this.jobs$ = this.jobService.autocomplete(input, [JobStatusEnum.Progress], 10);
    }
  }

  onAddProspect() {
    const selectedJob = this.jobFormControl.value;
    this.store.dispatch(
      sendAddAsProspect({ candidateId: this.data.candidateId, jobId: selectedJob.id }),
    );
    this.closeDialog();
  }
}
